/* Generated by ./script/iconify.js */
/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import IconBase from './IconBase'
import classnames from 'classnames'

const IconInfo = ({ className, ...rest }) => {
  const classes = classnames(
    'icon',
    'icon--info',
    className,
  )

  return (
    <IconBase className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"{...rest}><path className="path1" fill="#FFF" d="M9 15h2V9H9v6zm1-15C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zM9 7h2V5H9v2z"/></IconBase>
  )
}

IconInfo.propTypes = {
  className: PropTypes.string,
}

export default IconInfo
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/icons/IconInfo.js